import { defineComponent as p, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as V, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, h = { key: 1 }, w = { key: 2 }, H = { key: 3 }, A = { key: 4 }, k = { key: 5 }, M = {
  name: "ScalarIconArrowElbowDownRight"
}, _ = /* @__PURE__ */ p({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = m(s);
    return (i, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      V(i.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", f, l[0] || (l[0] = [
        n("path", { d: "M224.49,184.49l-48,48a12,12,0,0,1-17-17L187,188H72a12,12,0,0,1-12-12V32a12,12,0,0,1,24,0V164H187l-27.52-27.51a12,12,0,1,1,17-17l48,48A12,12,0,0,1,224.49,184.49Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", h, l[1] || (l[1] = [
        n("path", {
          d: "M216,176l-48,48V128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M221.66,170.34l-48-48A8,8,0,0,0,160,128v40H80V32a8,8,0,0,0-16,0V176a8,8,0,0,0,8,8h88v40a8,8,0,0,0,13.66,5.66l48-48A8,8,0,0,0,221.66,170.34ZM176,204.69V147.31L204.69,176Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", w, l[2] || (l[2] = [
        n("path", { d: "M221.66,181.66l-48,48A8,8,0,0,1,160,224V184H72a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8,8,0,0,1,13.66-5.66l48,48A8,8,0,0,1,221.66,181.66Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", H, l[3] || (l[3] = [
        n("path", { d: "M220.24,180.24l-48,48a6,6,0,0,1-8.48-8.48L201.51,182H72a6,6,0,0,1-6-6V32a6,6,0,0,1,12,0V170H201.51l-37.75-37.76a6,6,0,1,1,8.48-8.48l48,48A6,6,0,0,1,220.24,180.24Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", A, l[4] || (l[4] = [
        n("path", { d: "M221.66,181.66l-48,48a8,8,0,0,1-11.32-11.32L196.69,184H72a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168H196.69l-34.35-34.34a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,221.66,181.66Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", k, l[5] || (l[5] = [
        n("path", { d: "M218.83,178.83l-48,48a4,4,0,0,1-5.66-5.66L206.34,180H72a4,4,0,0,1-4-4V32a4,4,0,0,1,8,0V172H206.34l-41.17-41.17a4,4,0,1,1,5.66-5.66l48,48A4,4,0,0,1,218.83,178.83Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  _ as default
};
